module.exports = __webpack_public_path__ + "img/London_Map_2K.cf9b7386.jpg";